<script>
import LiveReportService from '@/services/ReportModules/LiveReportService'
import salesCheckListModal from '@/components/modals/sales/salesCheckListModal'

export default {
  props: {
    tableTitle: {
      type: String,
      default () {
        return ''
      }
    }
  },
  created () {
    this.location_id = this.$route.params.location_id
  },
  data () {
    return {
      employeeSummary: {
        sales: []
      },
      expanded: true
    }
  },
  methods: {
  },
  computed: {
    totalSales: function () {
      let s = 0
      this.employeeSummary.sales.forEach(e => {
        s += e.total
      })
      return s
    },
    totalGuests: function () {
      let s = 0
      this.employeeSummary.sales.forEach(e => {
        s += e.guestcount
      })
      return s
    },
    totalChecks: function () {
      let s = 0
      this.employeeSummary.sales.forEach(e => {
        s += e.checks
      })
      return s
    },
    totalDiscounts: function () {
      let s = 0
      this.employeeSummary.sales.forEach(e => {
        s += e.discounts
      })
      return s
    },
    totalVoids: function () {
      let s = 0
      this.employeeSummary.sales.forEach(e => {
        s += e.voids
      })
      return s
    }
  },
  mounted () {
    this.$updateloading(1)
    LiveReportService.getEmployeeSummary(this.location_id).then(data => {
      this.employeeSummary = data
      this.$updateloading(-1)
    })
  },
  components: {
    salesCheckListModal
  }
}

</script>

<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="well">
        <div class="list-group">
          <div class="list-group-item active">
            <div class="list-group-item-heading float-left">
              <strong>{{tableTitle}}</strong>
            </div>
            <div class="list-group-item-heading float-right">
              <a href="javascript:void(0)" v-on:click="expanded = !expanded">
                <i class="fas fa-minus-square" v-show="expanded"></i>
                <i class="fas fa-plus-square" v-show="!expanded"></i>
              </a>
            </div>
          </div>
          <div class="list-group-item" v-show="expanded">
            <div class="table-responsive">
              <table class="table table-condensed">
                <thead>
                  <tr>
                    <th>Employee</th>
                    <th class="text-right">Sales</th>
                    <th class="text-center">Chks / GstCt</th>
                    <th class="text-right">Disc / Vds</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(row, index) in this.employeeSummary.sales" :key="index">
                    <td>{{row.employee}}</td>
                    <td class="text-right">{{row.total | currency}}</td>
                    <td class="text-center">
                      <span v-show="row.checks > 0">
                        <sales-check-list-modal
                          :locationId="location_id"
                          :startDate="row.date"
                          :employeeId="row.employee_id"
                          :inday="true"
                        >{{ row.checks }}</sales-check-list-modal>
                      </span>
                      <span v-show="row.checks == 0">{{ row.checks }}</span>
                      /
                      {{row.guestcount}}
                    </td>
                    <td class="text-right">
                      <sales-check-list-modal
                        :locationId="location_id"
                        :startDate="row.date"
                        :employeeId="row.employee_id"
                        :inday="true"
                        :discountOnly="true"
                      >{{row.discounts | currency}}</sales-check-list-modal>&nbsp;/
                      <sales-check-list-modal
                        :locationId="location_id"
                        :startDate="row.date"
                        :employeeId="row.employee_id"
                        :inday="true"
                        :voidOnly="true"
                      >{{row.voids | currency}}</sales-check-list-modal>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th></th>
                    <th class="text-right">{{totalSales | currency}}</th>
                    <th class="text-center">{{totalChecks}} / {{totalGuests}}</th>
                    <th class="text-right">{{totalDiscounts | currency}} / {{totalVoids | currency}}</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
